// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-company-contacts-indexstyleGrid-container-sacch{margin:0 auto;max-width:1536px;padding:0 24px;width:100%}.pages-company-contacts-indexstyleGrid-grid-bqqhn{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-company-contacts-indexstyleGrid-col6-czhxx{grid-column:span 6}.pages-company-contacts-indexstyleGrid-col3-smckq{grid-column:span 3}.pages-company-contacts-indexstyleGrid-col4-freyl{grid-column:span 4}.pages-company-contacts-indexstyleGrid-col9-bhncx{grid-column:span 9}.pages-company-contacts-indexstyleGrid-col12-bzupk{grid-column:span 12}.pages-company-contacts-indexstyleGrid-alignItemsStart-bhjre{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-company-contacts-indexstyleGrid-container-sacch",
	"grid": "pages-company-contacts-indexstyleGrid-grid-bqqhn",
	"col6": "pages-company-contacts-indexstyleGrid-col6-czhxx",
	"col3": "pages-company-contacts-indexstyleGrid-col3-smckq",
	"col4": "pages-company-contacts-indexstyleGrid-col4-freyl",
	"col9": "pages-company-contacts-indexstyleGrid-col9-bhncx",
	"col12": "pages-company-contacts-indexstyleGrid-col12-bzupk",
	"alignItemsStart": "pages-company-contacts-indexstyleGrid-alignItemsStart-bhjre"
};
module.exports = ___CSS_LOADER_EXPORT___;
